import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "wago-energy-heatmap-header",
  class: "wago-heatmap__header chart-header"
}
const _hoisted_2 = {
  id: "wago-energy-heatmap-title",
  class: "wago-heatmap__title chart-title"
}
const _hoisted_3 = { class: "wago-heatmap__title-text" }
const _hoisted_4 = {
  id: "wago-energy-heatmap-actions",
  class: "wago-heatmap__actions chart-actions"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  id: "wago-energy-heatmap-body",
  class: "wago-heatmap__body chart-body"
}
const _hoisted_7 = {
  key: 0,
  id: "wago-energy-heatmap-empty",
  class: "wago-heatmap__empty heatmap-empty"
}
const _hoisted_8 = {
  key: 1,
  id: "wago-energy-heatmap-scroll",
  class: "wago-heatmap__scroll heatmap-scroll-wrapper"
}
const _hoisted_9 = {
  id: "wago-energy-heatmap-table",
  class: "wago-heatmap__table heatmap-table"
}
const _hoisted_10 = { class: "wago-heatmap__head-row" }
const _hoisted_11 = {
  id: "wago-energy-heatmap-series-col",
  class: "wago-heatmap__series-col heatmap-series-col"
}
const _hoisted_12 = ["id"]
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "wago-heatmap__series-col wago-heatmap__series-label heatmap-series-col heatmap-series-label" }
const _hoisted_15 = ["id", "title"]
const _hoisted_16 = {
  key: 0,
  class: "wago-heatmap__cell-value heatmap-cell-value"
}
const _hoisted_17 = {
  key: 1,
  class: "wago-heatmap__no-data heatmap-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "wago-energy-heatmap",
    class: _normalizeClass(["wago-heatmap chart-container chart-container--wago mb-3 px-0", { 'dark-mode': _ctx.isDarkMode }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "wago-heatmap__title-icon bi bi-grid-3x3-gap-fill" }, null, -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('components.assetDetails.wagoHeatmap.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          id: "wago-energy-heatmap-export-csv",
          class: "wago-heatmap__export-btn btn btn-custom chart-action-export",
          type: "button",
          title: _ctx.$t('components.assetDetails.wagoHeatmap.exportCsv'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "wago-heatmap__export-icon bi bi-filetype-csv" }, null, -1)
        ]))], 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.hours.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('components.assetDetails.noHistory')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_10, [
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('components.assetDetails.seriesTable.series')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                    return (_openBlock(), _createElementBlock("th", {
                      id: _ctx.getHourHeaderId(hour),
                      key: hour,
                      class: "wago-heatmap__hour-col heatmap-hour-col"
                    }, _toDisplayString(_ctx.formatHour(hour)), 9, _hoisted_12))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.energySeries, (series) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    id: _ctx.getSeriesRowId(series.key),
                    key: series.key,
                    class: "wago-heatmap__series-row"
                  }, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("span", {
                        class: "wago-heatmap__series-dot heatmap-series-dot",
                        style: _normalizeStyle({ background: series.dotColor })
                      }, null, 4),
                      _createTextVNode(" " + _toDisplayString(series.label), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                      return (_openBlock(), _createElementBlock("td", {
                        id: _ctx.getCellId(series.key, hour),
                        key: hour,
                        class: "wago-heatmap__cell heatmap-cell",
                        style: _normalizeStyle(_ctx.cellStyle(series.key, hour)),
                        title: _ctx.cellTitle(series.key, hour, series.unit)
                      }, [
                        (_ctx.getCellDelta(series.key, hour) !== null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.formatValue(_ctx.getCellDelta(series.key, hour)!, series.unit)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
                      ], 12, _hoisted_15))
                    }), 128))
                  ], 8, _hoisted_13))
                }), 128))
              ])
            ])
          ]))
    ])
  ], 2))
}